import axios from "axios";
import { isFieldWithValue } from "../utils";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const GetPlaces = async (payload) => {
  return await api.post(`/places/public-list`, payload);
};

export const GetPlaceDetails = async (code) => {
  return await api.get(`/places/public-details/${code}`);
};

export const Authentication = async (payload) => {
  return await api.post(`/authentication/login`, payload);
};

export const Registration = async (payload) => {
  return await api.post("/users/registration", payload);
};

export const RefreshToken = async (token) => {
  return await api.get(`/authentication/verify/${token}`);
};

export const GetStatsAdmin = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/companies/stats-admin`, payload)
}

export const GetDashboardStats = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/dashboard/data`, payload);
};

export const GetHouses = async (payload) => {
  // api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/houses/public-list`, payload);
};

export const GetHouseDetails = async (code) => {
  return await api.get(`/houses/${code}`);
};

export const GetHousePrivateDetails = async (code, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.get(`/houses/private/${code}`);
};

export const GetReservations = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/list`, payload);
};

export const GetPublicReservations = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/public-list`, payload);
};

export const GetCompanies = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/companies/list`, payload);
};

export const VerifyPhoneNumber = async (payload) => {
  return await api.post("/users/exists", payload);
};

export const NewReservation = async (payload) => {
  return await api.post("/reservations/public-request", payload);
};

export const GetReservationInfos = async (code, privateCode = '', managerCode = '') => {
  const key =  isFieldWithValue(privateCode) ? privateCode : null;
  const manager = isFieldWithValue(managerCode) ? managerCode : null;
  const params = key || manager ? { key, manager } : {} ;
  return await api.get(`/reservations/${code}`, { params });
};

export const SubmitReview = async (payload) => {
  return await api.post(`/reservations/review`, payload);
};

export const RegisterPartner = async (payload) => {
  return await api.post("/companies/register", payload);
};

export const RegistrationRequest = async (payload, key = "") => {
  // api.defaults.headers["client-data"] = key?.substring(0, 7);
  // api.defaults.headers["application-id"] = key?.substring(7);
  return await api.post("/users/registration-request", payload);
};

export const VerifyOTP = async (payload) => {
  return await api.post("/users/verify-otp", payload);
};

export const GetPrivateHouses = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/houses/list`, payload);
};

export const CreateHouse = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/houses`, payload);
};

export const UpdateHouse = async (code, payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.patch(`/houses/${code}`, payload);
};

export const UpdateHouseRules = async (code, payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.patch(`/houses/${code}/policy`, payload);
};

export const AddHouseUser = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/houses/manager`, payload);
};

export const RemoveHouseUser = async (code, phone, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.delete(`/houses/${code}/users/${encodeURIComponent(phone)}`);
};

export const GetPlacePrivateDetails = async (code, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.get(`/places/${code}`);
};

export const UpdatePlace = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/places/update`, payload);
};

export const GetPrivatePlaces = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/places/list`, payload);
};

export const BatchCreatePlaces = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/places/new-batch`, payload);
};

export const GetPublicListings = async (payload) => {
  return await api.post(`/listings/public/list`, payload);
};

export const GetListings = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/listings/list`, payload);
};

export const CreateListing = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/listings/new`, payload);
};

export const UpdateListing = async (code, payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.patch(`/listings/${code}`, payload);
};

// export const DeleteListing = async (code, token) => {
//   api.defaults.headers["Authorization"] = `Bearer ${token}`;
//   return await api.delete(`/listings/${code}`);
// };

export const PublishListing = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/listings/publish`, payload);
};

export const PauseListing = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/listings/pause`, payload);
};

export const AcceptReservation = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/accept-request`, payload);
};

export const RejectReservation = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/reject-request`, payload);
};

export const SavePushToken = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/users/web/pushtokens`, payload);
};

export const RemovePushToken = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/users/web/pushtokens/remove`, payload);
};

export const DeclineReservation = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/decline-request`, payload);
};

export const ExtendReservation = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/extend`, payload);
};

export const EndReservation = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/end`, payload);
};

export const UpdateCheckinTime = async (payload) => {
  return await api.post(`/reservations/public-update-checkin`, payload);
};

export const ClaimReservation = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/public-claim`, payload);
};

export const GetPublicListingDetails = async (code) => {
  return await api.get(`/listings/public/${code}`);
};

export const GetReviews = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/reservations/reviews/list`, payload);
};

// ── Messagerie réservation (client ↔ hôte) ──
// Côté client (page publique de suivi) : accès via code réservation + clé privée
export const GetPublicMessages = async (payload) => {
  return await api.post(`/messages/public-list`, payload);
};

export const SendPublicMessage = async (payload) => {
  return await api.post(`/messages/public-send`, payload);
};

// Côté hôte (dashboard) : accès authentifié
export const GetMessages = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/messages/list`, payload);
};

export const SendMessage = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/messages/send`, payload);
};

export const GetUnreadMessagesCount = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/messages/unread-count`, payload);
};

// Boîte de réception de l'hôte : toutes les conversations liées à ses réservations
export const GetConversations = async (payload, token) => {
  api.defaults.headers["Authorization"] = `Bearer ${token}`;
  return await api.post(`/messages/conversations`, payload);
};

export const API = {
  CreateHouse,
  GetPlaces,
  GetPlaceDetails,
  Authentication,
  Registration,
  RefreshToken,
  GetStatsAdmin,
  GetDashboardStats,
  GetHouses,
  GetHouseDetails,
  GetReservations,
  GetCompanies,
  VerifyPhoneNumber,
  NewReservation,
  GetReservationInfos,
  RegisterPartner,
  RegistrationRequest,
  VerifyOTP,
  GetPublicReservations,
  SubmitReview,
  GetPrivateHouses,
  UpdateHouse,
  UpdateHouseRules,
  GetHousePrivateDetails,
  AddHouseUser,
  RemoveHouseUser,
  GetPlacePrivateDetails,
  UpdatePlace,
  GetPrivatePlaces,
  BatchCreatePlaces,
  GetPublicListings,
  GetListings,
  CreateListing,
  UpdateListing,
  // DeleteListing,
  PublishListing,
  PauseListing,
  AcceptReservation,
  DeclineReservation,
  ExtendReservation,
  EndReservation,
  RejectReservation,
  SavePushToken,
  RemovePushToken,
  UpdateCheckinTime,
  ClaimReservation,
  GetPublicListingDetails,
  GetReviews,
  GetPublicMessages,
  SendPublicMessage,
  GetMessages,
  SendMessage,
  GetUnreadMessagesCount,
  GetConversations,
};
